export default __webpack_public_path__ + "static/media/b2b.5ad58396.svg";